import { Pipe, PipeTransform } from '@angular/core';
import { Assignment } from '@apaq/orgkit-js';

@Pipe({
  name: 'duration'
})
export class DurationPipe implements PipeTransform {

  transform(value: number, format?: string): any {

    if (format === 'short') {
      if (value === 0) {
        return '0,0t';
      }

      return (value / 60).toFixed(1) + 't';
    } else {
      if (value === 0) {
        return '0t0m';
      }

      return Math.floor(value / 60) + 't' + Math.floor(value % 60) + 'm';
    }
  }

}
